export const Colors = {
    pink:'#DC99F3',
    bone:'#FDF2D4',
    green:'#5FAE51',
    yellow:'#F1C945',
    blue:'#3C7BDA',
    red:'#E46D47'
}